<template>
    <div class="csq">
        <div class="csq-title">Screening Questions</div>

        <div class="csq-list">
            <div v-for="q in questions" :key="q.QuestionId" class="csq-item"
                :class="{ bad: q.IsKnockout && answers[q.QuestionId] === 'No' }">
                <div class="q">
                    {{ q.QuestionText }}
                    <span v-if="q.IsKnockout" class="chip ko">Knockout</span>
                </div>

                <div class="seg">
                    <button type="button" class="seg-btn" :class="{ active: answers[q.QuestionId] === 'Yes' }"
                        @click="set(q.QuestionId, 'Yes')">Yes</button>
                    <button type="button" class="seg-btn" :class="{ active: answers[q.QuestionId] === 'No' }"
                        @click="set(q.QuestionId, 'No')">No</button>
                </div>

                <div class="err" v-if="q.IsKnockout && answers[q.QuestionId] === 'No'">
                    This employer requires "Yes" to proceed.
                </div>
            </div>
        </div>

        <div v-if="!answeredAll" class="csq-block">Please answer all questions.</div>
        <div v-else-if="!passedKnockouts" class="csq-block">You must meet all knockout questions (answer “Yes”) to
            apply.</div>
    </div>
</template>

<script>
export default {
    name: 'CandidateScreeningApply',
    props: {
        questions: {          
            type: Array,
            default: () => []
        }
    },
    data() {
        const answers = {};
        this.questions.forEach(q => {
            answers[q.QuestionId] = undefined;  
        });
        return { answers };
    },
    computed: {
        answeredAll() { return this.questions.every(q => this.answers[q.QuestionId] === 'Yes' || this.answers[q.QuestionId] === 'No'); },
        passedKnockouts() { return this.questions.every(q => !q.IsKnockout || this.answers[q.QuestionId] === 'Yes'); }
    },
    methods: {
        set(questionId, val) { this.$set(this.answers, questionId, val); },
        validate() { return { ok: this.answeredAll && this.passedKnockouts }; },
        getPayload() {
            return this.questions.map(q => ({
                questionId: q.QuestionId,
                answer: this.answers[q.QuestionId] || null}));
        }
    }
};
</script>

<style>
.csq {
    border: 1px solid #e9eaef;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
}

.csq-title {
    font-weight: 600;
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
}

.csq-list {
    display: grid;
    gap: 8px;
}

.csq-item {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 6px;
    padding: 8px 10px;
}

.csq-item.bad {
    border-left: 3px solid #f5222d;
}

.q {
    font-size: 13px;
    color: #333;
    margin-bottom: 6px;
}

.chip.ko {
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 10px;
    background: #fff1f0;
    color: #a8071a;
    border: 1px solid #ffa39e;
    margin-left: 6px;
}

.seg {
    display: inline-flex;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    overflow: hidden;
    height: 28px;
}

.seg-btn {
    appearance: none;
    border: none;
    background: #fff;
    padding: 0 12px;
    font-size: 12px;
    line-height: 26px;
    cursor: pointer;
    border-right: 1px solid #eee;
}

.seg-btn:last-child {
    border-right: 0;
}

.seg-btn:hover {
    background: #f6f8ff;
}

.seg-btn.active {
    background: #2a41e8;
    color: #fff;
}

.err {
    margin-top: 6px;
    font-size: 12px;
    color: #a8071a;
}

.csq-block {
    margin-top: 8px;
    padding: 6px 8px;
    font-size: 12px;
    color: #a8071a;
    background: #fff1f0;
    border: 1px solid #ffa39e;
    border-radius: 6px;
}
</style>
